// import ReactDOM from 'react-dom/client';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loading } from '@alifd/next';
import { buildComponents, AssetLoader } from '@alilc/lowcode-utils';
import ReactRenderer from '@alilc/lowcode-react-renderer';
// import { injectComponents } from '@alilc/lowcode-plugin-inject';

export const PageView = () => {
    const [queries] = useSearchParams();
    const [schema_id] = useState(queries.get('id'));
    const [data, setData] = useState({});

    async function init() {
        // 渲染前置处理，初始化项目 schema 和资产包为渲染模块所需的 schema prop 和 components prop
        // const packages = JSON.parse(window.localStorage.getItem('packages') || '');
        // const projectSchema = JSON.parse(window.localStorage.getItem('projectSchema') || '');
        const assets = await (
            await fetch(
                process.env.REACT_APP_LC_JSON + `/lowcode-assets.json`, { mode: 'cors' }
            )
        ).json();
        const packages = assets.packages;
        const res = await (
            await fetch(
                process.env.REACT_APP_LC_FED + `/lowcode/page/get`,
                {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ id: schema_id })
                }
            )
        ).json();
        const schemaStr = res.data.schema;
        // console.log(schemaStr)
        const projectSchema = JSON.parse(schemaStr);

        const { componentsMap: componentsMapArray, componentsTree } = projectSchema;

        // console.log('packages =>', packages);
        // console.log('projectSchema =>', projectSchema);

        const componentsMap = {};
        componentsMapArray.forEach((component) => {
            componentsMap[component.componentName] = component;
        });
        const schema = componentsTree[0];

        const libraryMap = {};
        const libraryAsset = [];
        packages.forEach(({ package: _package, library, urls, renderUrls }) => {
            libraryMap[_package] = library;
            if (renderUrls) {
                libraryAsset.push(renderUrls);
            } else if (urls) {
                libraryAsset.push(urls);
            }
        });

        // const vendors = [assetBundle(libraryAsset, AssetLevel.Library)];

        const assetLoader = new AssetLoader();
        await assetLoader.load(libraryAsset);
        const components = buildComponents(libraryMap, componentsMap);

        setData({
            schema,
            components,
        });
    }

    const { schema, components } = data;

    if (!schema || !components) {
        init();
        return <Loading fullScreen />;
    }

    return (
        <div className="lowcode-plugin-sample-preview">
            <ReactRenderer
                className="lowcode-plugin-sample-preview-content"
                schema={schema}
                components={components}
            />
        </div>
    );
};

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render((
//   <PageView />
// ));